import gql from 'graphql-tag'

export const CORRESPONDENCE_LETTER_PREVIEW_CREATE_MUTATION = gql`
    mutation correspondenceLetterPreviewCreate(
        $id: ID!
        $targetObjectId: ID!
    ) {
        correspondenceLetterPreviewCreate(
            id: $id
            target_object_id: $targetObjectId
        )
    }
`
